// frontend/src/pages/PublicPortfolio.tsx
import React from 'react';
import { useParams } from 'react-router-dom';
import PortfolioView from '../components/public/PortfolioView';

const PublicPortfolio: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Invalid Portfolio URL</h1>
        <p>No portfolio slug provided</p>
      </div>
    );
  }

  return <PortfolioView slug={slug} />;
};

export default PublicPortfolio;